import type { AssetCategory } from '@yawi/types';

/**
 * Default asset categories
 * These are used as fallback when the API endpoint is not available
 * To enable API-based categories, implement the getCategories endpoint
 * and update useAssetCategories hook to use it
 */
export const DEFAULT_ASSET_CATEGORIES: AssetCategory[] = [
  {
    id: 'cat-tools',
    name: 'Herramientas',
    description: 'Herramientas manuales y eléctricas',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-electronics',
    name: 'Electrónicos',
    description: 'Equipos electrónicos y de cómputo',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-furniture',
    name: 'Mobiliario',
    description: 'Muebles y mobiliario de oficina',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-maintenance',
    name: 'Equipo de Mantenimiento',
    description: 'Equipos para mantenimiento de instalaciones',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-cleaning',
    name: 'Equipo de Limpieza',
    description: 'Equipos y máquinas de limpieza',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-security',
    name: 'Equipo de Seguridad',
    description: 'Cámaras, sensores y equipo de vigilancia',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-garden',
    name: 'Jardinería',
    description: 'Herramientas y equipo de jardinería',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-pool',
    name: 'Equipo de Alberca',
    description: 'Equipos y accesorios para alberca',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-gym',
    name: 'Equipo de Gimnasio',
    description: 'Máquinas y equipo de ejercicio',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-vehicles',
    name: 'Vehículos',
    description: 'Vehículos y carritos de servicio',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'cat-other',
    name: 'Otros',
    description: 'Otros activos no categorizados',
    parentCategoryId: null,
    assetCount: 0,
    createdAt: new Date().toISOString(),
  },
];

/**
 * Category labels for i18n support
 * Key format: inventory.category.{categoryId}
 */
export const CATEGORY_LABELS: Record<string, { es: string; en: string }> = {
  'cat-tools': { es: 'Herramientas', en: 'Tools' },
  'cat-electronics': { es: 'Electrónicos', en: 'Electronics' },
  'cat-furniture': { es: 'Mobiliario', en: 'Furniture' },
  'cat-maintenance': { es: 'Equipo de Mantenimiento', en: 'Maintenance Equipment' },
  'cat-cleaning': { es: 'Equipo de Limpieza', en: 'Cleaning Equipment' },
  'cat-security': { es: 'Equipo de Seguridad', en: 'Security Equipment' },
  'cat-garden': { es: 'Jardinería', en: 'Gardening' },
  'cat-pool': { es: 'Equipo de Alberca', en: 'Pool Equipment' },
  'cat-gym': { es: 'Equipo de Gimnasio', en: 'Gym Equipment' },
  'cat-vehicles': { es: 'Vehículos', en: 'Vehicles' },
  'cat-other': { es: 'Otros', en: 'Other' },
};
